module.exports = __webpack_public_path__ + "components/country-flag/static/io-d707179057ac9dc687e784540382cd0f.svg";